<script setup lang="ts">
import { computed } from 'vue';
import CoreIcon from '@core/core-icon.vue';

const props = defineProps({
	name: {
		type: String,
		default: null
	},
	label: {
		type: String,
		default: null
	},
	icon: {
		type: Object,
		default: () => {}
	},
	panel: {
		type: Boolean,
		default: false
	},
	trueValue: {
		type: [String, Boolean],
		default: true
	},
	falseValue: {
		type: [String, Boolean],
		default: false
	},
	tag: {
		type: String,
		default: 'label'
	}
});
const modelValue = defineModel();

const modes = computed(() => {
	return {
		'form-toggle_panel': props.panel
	};
});
</script>
<template>
	<component :is="tag" class="form-toggle" :class="modes">
		<core-icon
			v-if="icon"
			v-bind="icon"
			class="form-toggle__icon"
		/>
		<span v-if="label" class="form-toggle__label">{{ label }}</span>
		<input
			type="checkbox"
			:name="name"
			:true-value="trueValue"
			:false-value="falseValue"
			class="form-toggle__input"
			v-model="modelValue"
		>
		<span class="form-toggle__switch">

		</span>
	</component>
</template>

<style lang="scss">
.form-toggle {
	cursor: pointer;
	display: flex;
	// justify-content: space-between;
	align-items: center;
	gap: 1.6rem;

	&_panel {
		background-color: var(--color-panel);
		border: 1px solid var(--color-panel);
		padding: 1.6rem 1.7rem;
		border-radius: 1.6rem;
		transition: ease 0.12s;
		@include min-desktop {
			&:hover {
				background-color: rgba(var(--color-active-rgb), 0.10);
			}
		}
	}

	&__icon {
		width: 2.4rem;
		fill: var(--color-active);
	}

	&__label {
		margin-right: auto;
		@include min-desktop {
			@include font-18-pro-medium;
		}
	}

	&__input {
		display: none;
		// appearance: auto;

		&:checked {
			&+.form-toggle {
				&__switch {
					background-color: var(--color-purple);
					&::before {
						left: calc(var(--input-width, 4.6rem) - var(--input-inner-size, 1.6rem) - 0.6rem);
					}
				}
			}
		}
	}

	&__switch {
		width: var(--input-width, 4.6rem);
		height: var(--input-height, 2.8rem);
		border-radius: 10rem;
		position: relative;
		background: linear-gradient(0deg, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)), rgba(115, 93, 207, 0.25);
		transition: background-color ease .2s;

		@include theme-dark {
			background: var(--color-panel);
		}


		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 0.6rem;
			left: 0.6rem;
			width: var(--input-inner-size, 1.6rem);
			height: var(--input-inner-size, 1.6rem);
			border-radius: 50%;
			background-color: var(--color-white);
			transition: left ease .2s;
		}
	}
}
</style>
